// extracted by mini-css-extract-plugin
module.exports = {"favouritesIcon":"favouritesIcon___1uFew","favouritesIconFilled":"favouritesIconFilled___3UpsK"};